import { createFileRoute } from "@tanstack/react-router";
import { OwnResident } from "@/components/app/portal/pages/own-resident";
import { ResidentDocumentsPage } from "@/components/app/portal/pages/resident-documents-page";

export const Route = createFileRoute("/resident-portal/documents")({
  head: () => ({ meta: [{ title: "Documents | People AI" }] }),
  component: ResidentDocuments,
});

function ResidentDocuments() {
  return (
    <OwnResident>
      {(own) => <ResidentDocumentsPage kind="resident" residentId={own.residentId} />}
    </OwnResident>
  );
}
